module.exports = require("angular-dynamic-locale");